<template>
  <div class="app-wrapp">
    <section class="bg-clay">
      <div class="article-wrapper">
        <div class="article-head">
          <h2 class="article-head__title">
            <div class="animated fadeInLeft" style="opacity: 0;">
              {{ 'В России миллионы матерей-одиночек с детьми. Как государство помогло им справиться с трудностями в жизни?' | typograf}}
            </div>
            <div class="article-head__line article-head__line--a1 img-w">
              <img src="@/assets/img/article1/line1.png" alt="">
            </div>
          </h2>
          <div class="article-head__img img-w animated fadeInBottomRight">
            <img src="@/assets/img/article1/img1.png" alt="">
          </div>
        </div>
      </div>
    </section>

    <section class="article-text bg-clay article-text--pre-blue">
      <div class="mobile-hidden article__img article__img1 img-w" style="opacity: 0;" v-animate-onscroll="'animated fadeInLeft'">
        <img src="@/assets/img/article1/img2.png" alt="">
      </div>
      <div class="mobile-hidden article__img article__img2 img-w" v-animate-onscroll="'animated fadeInRight'">
        <img src="@/assets/img/article1/img3.png" alt="">
      </div>
      <div class="article-wrapper">
        <h3 class="article-text__h3" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          «Говорили, что я пложу нищету»
        </h3>
        <p class="article-text__subtitle" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{'Один из самых сложных периодов для любой семьи приходится на то время, когда заканчивается отпуск по уходу за малышом. У молодой матери проблем столько, что порой из-за частых болезней ребенка и режима работы детского сада совсем нет времени на работу.' | typograf }}
        </p>
        <p class="article-text__enlarged" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Жительница Казани и опытный повар Юлия Хлебова прекрасно это понимает.' | typograf }}
        </p>
        <p class="article-text__text" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ 'В юности, как и многие ее сверстницы, Юлия мечтала о карьере и счастливой семье. Она жадно впитывала все новое, почти не думая бросалась помогать окружающим. Казалось, что ей разом удается делать все — она успевала быть волонтером, учиться, работать, перебравшись из родной Казани в Москву. В столице познакомилась с парнем и стала строить с ним серьезные отношения. Но все изменилось, когда она забеременела. Партнер настаивал на аборте, но Юлия отказалась. Во многом из-за религиозных убеждений. Пара рассталась.' | typograf }}
        </p>
        <div class="mobile-visible article__img img-w">
          <img src="@/assets/img/article1/img2-mob.png" alt="">
        </div>
        <div class="article-text__quote" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[0]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}"
                v-html="letter + ' '"></span>
        </div>
        <p class="article-text__text" style="opacity: 0;" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Сперва начальник оставил Хлебову без декретного отпуска, а потом и вовсе уволил, лишив всех средств к существованию. ' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Выжить женщине помогли добрые люди из церковного прихода. У одного из них она жила какое-то время после родов, а потом уехала обратно в Казань.' | typograf }}
        </p>
        <div class="mobile-visible article__img img-w article__img--fr">
          <img src="@/assets/img/article1/img3.png" alt="">
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Перебиваясь помощью от друзей, волонтеров и благотворителей, Хлебова растила ребенка одна, а когда дочь доросла до детсадовского возраста, устроилась на работу.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Казалось, что жизнь постепенно налаживалась. ' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Но потом был второй роман, еще одна беременность и в очередной раз разбитое сердце. Уже после расставания Юлия узнала, что у нее будет двойня.' | typograf }}
        </p>
        <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[1]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}"
                v-html="letter + ' '"></span>
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Но Хлебова выстояла. Родила здоровых мальчика и девочку. Теперь старшей дочери девять лет, а младшим — по четыре года.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Все вчетвером мы уже два года ютимся в однокомнатной квартире, принадлежащей дяде. На момент моего с детьми переезда здесь не было никакого ремонта. Все сама приводила в порядок», — признается женщина.' | typograf }}
        </p>
        <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[2]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}"
                v-html="letter + ' '"></span>
        </div>
      </div>
      <div class="article-text__shifted-box">
        <div class="article__img article__img3 img-w" v-animate-onscroll="'animated fadeInLeft'">
          <img src="@/assets/img/article1/img4.png" alt="">
        </div>
        <div class="article__line article__line2 img-w" style="opacity: 0;" v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article1/line2.png" alt="">
        </div>
        <div class="article-wrapper article-wrapper--shifted">
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'У Юлии формально есть работа. Но толком заработать ей не удается. Уход за тремя детьми отнимает время и силы. ' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ '«Когда двойняшкам было два года и один месяц, я их устроила в ясли, но они тут же стали друг за другом болеть», — сетует одинокая многодетная мать. ' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Больше всего ее печалит, что все приходится делать самой: «Прямо надо мной живет семья: дедушка с бабушкой, их дочь с мужем и двойняшками того же возраста, что и мои. И знаете что? Я всего пару раз видела, чтобы родители сами вели детей в сад и приводили их обратно. Обычно этим занимаются дедушка с бабушкой. Зато у мамы с папой остается время на работу».' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Но надеяться Юлия может только на себя. Родных у нее нет. Мать умерла когда девочке было семь лет. Что до родного отца, то он давно перестал участвовать в ее жизни. ' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Постоянный стресс не мог не сказаться. Долгие годы она жила в постоянной тревоге за детей. На этой почве у Юлии произошло психологическое выгорание.' | typograf }}
          </p>
          <div class="article-text__quote" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[3]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.05*index + 's'}" v-html="letter + ' '"></span>
          </div>
        </div>
      </div>
      <div class="article-wrapper">
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'История Хлебовой — это один из самых сложных вариантов, когда выбраться из малоимущего, а по сути, нищенского состояния практически невозможно, даже непьющему человеку с сильным характером, каким является Юлия.' | typograf }}
        </p>
        <Loading :class="{'is-loading-animated': isLoading}" />
        <div class="observer-move"></div>
        <Layers />
      </div>
    </section>

    <section id="element-container" class="article-text article-text--blue article-text--blue1 -no-blue">
      <div id="element-content">
        <div class="article-wrapper article-wrapper--inner">
          <h3 id="element" class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
            {{ '«Даже в СССР такой поддержки не было»' | typograf }}
          </h3>
          <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Но ситуация меняется на глазах. В стране заработали масштабные меры социальной поддержки семей.' | typograf }}
          </p>
          <p class="article-text__enlarged" v-animate-onscroll="'animated fadeInUp'">
            {{ '«Мы уже расширили программу материнского капитала, увеличили его размер, предусмотрели пособия для беременных женщин, ежемесячные выплаты на детей в возрасте до 7 лет, а для детей, растущих в неполных семьях, до 16 лет включительно, — заявил президент России Владимир Путин, выступая 24 августа на съезде «Единой России». ' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Но, по словам президента, скоро соцвыплат станет еще больше.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ '«Задача следующих лет — расширить линейку социальной помощи, чтобы нуждающаяся семья могла получать поддержку все время: от рождения ребенка и до окончания им школы», — сказал Путин.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Он также обратил внимание, что семья и должна стать образом России будущего. «Крепкая, благополучная семья, в которой растут двое, трое, четверо детей», — подчеркнул президент.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Впрочем, поддержкой семей «Единая Россия» занимается много лет. В стране уже более 15 лет действует партийный проект «Крепкая семья».' | typograf }}
          </p>
        </div>
        <div class="article-text__shifted-box">
          <div class="article__img article__img4 img-w"  v-animate-onscroll="'animated fadeInRight'">
            <img src="@/assets/img/article1/img5.png" alt="">
          </div>
          <div class="article__line article__line3 img-w"  v-animate-onscroll="'animated fadeInLeft'">
            <img src="@/assets/img/article1/line3.png" alt="">
          </div>
          <div class="article-wrapper article-wrapper--inner article-wrapper--shifted-right">
            <div class="article-text__quote2"  v-animate-onscroll="'animated fadeInUp'">
              <div class="article-text__quote-icon img-w">
                <img src="@/assets/img/quote.png" alt="">
              </div>
              {{ '«Через наши семейные приемные в регионах мы стали получать обращения от людей, на основании которых подготовили свои предложения и обратились к Минтруду, чтобы внести коррективы и решить проблемы тех семей, которые особенно нуждались в новых пособиях, но не могли их получить», — рассказала координатор «Крепкой семьи», первый зампредседателя Госдумы по вопросам семьи Ольга Окунева.' | typograf }}
            </div>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Основная проблема заключалась в том, что реально малоимущие домохозяйства, которые, к примеру, получали пособия за опекунство, выплаты по уходу за детьми с инвалидностью или единовременную помощь из-за стихийных бедствий, уже на новые пособия рассчитывать не могли.' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'В то же время люди, скрывающие свои реальные доходы, но при этом, судя по богатому имуществу, не являющиеся нуждающимися, выплаты получали.' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Окунева и ее коллеги вместе с чиновниками Минтруда постарались сделать все возможное, чтобы подготовить такие поправки, которые бы устранили эту явную несправедливость.' | typograf }}
            </p>
          </div>
        </div>
        <div class="article-text__shifted-box article-text__shifted-box--mt">
          <div class="article__img article__img5 img-w" v-animate-onscroll="'animated fadeInLeft'">
            <img src="@/assets/img/article1/img6.png" alt="">
          </div>
          <div class="article__line article__line4 img-w"  v-animate-onscroll="'animated fadeInUp'">
            <img src="@/assets/img/article1/line4.png" alt="">
          </div>
          <div class="article-wrapper article-wrapper--inner article-wrapper--shifted-left article-wrapper--mt">
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'В итоге 10 марта 2021 года президент России подписал новый указ, который начиная с 1 апреля ввел куда более адресный подход в распределении пособий и заметно увеличил их размер для наиболее нуждающихся граждан.' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Новая система учитывает не только подушевой доход семьи, но и ее реальную имущественную обеспеченность, а также стремление родителей работать, а не жить только на пособие, без уважительных на то причин.' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Семья сохраняет право на пособие, если у нее есть машина с двигателем, мощность которого меньше 250 лошадиных сил, квартира и дача. Но если квартира не одна, а две, а в банке лежит несколько миллионов рублей, то выплат не будет.' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Учитываются и авторские гонорары, и проценты по вкладами, и доходы от сдачи в аренду имущества, но, к примеру, выплаты пособий по уходу за детьми с инвалидностью и опекунство в расчет уже не идут. Алименты тоже считают, но только реально поступившие на счет суммы.' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'А еще сделано важное исключение, согласно которому студенты-очники в возрасте до 23 лет, которые полностью находятся на содержании родителей, учитываются наравне с несовершеннолетними детьми.' | typograf }}
            </p>
            <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
              {{ 'Требование работать официально является обязательным тоже не для всех. Уважительные причины оставаться дома, как в ситуации с многодетной матерью-одиночкой Юлией Хлебовой, позволяют получать пособия и безработным. Но самое главное, что введен дифференцированный подход при определении самого размера пособий.' | typograf }}
            </p>
          </div>
        </div>
        <div class="article-wrapper article-wrapper--inner article-wrapper--pb">
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Базовой остается прежняя выплата в 50 процентов от прожиточного минимума в регионе. На выплаты в 75 процентов уже могут рассчитывать те семьи, в которых после получения базового пособия среднедушевой доход останется ниже прожиточного минимума. Наконец, 100 процентов получают те, кому недостаточно и 75-процентного пособия.' | typograf }}
          </p>
          <div class="article-text__quote2" v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote.png" alt="">
            </div>
            {{ '«В апреле я пришла в соцзащиту, где я каждые полгода отмечаюсь как малоимущая мать троих детей, и у меня заодно приняли документы на выплату новых пособий, — рассказывает Юлия Хлебова. — Старшей дочери 9 лет. Она уже школьница, но на младших двойняшек, которым сейчас по 4 года, мне платят. В прошлом году — по 4500 рублей, и мне приходило 9 000 рублей (прожиточный минимум в Татарстане на 2021 год составляет 9955 рублей). Теперь выплаты увеличили примерно на 2000 рублей на каждого! Для меня это очень ощутимо».' | typograf }}
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'По словам Хлебовой, этих пособий ей уже хватает на то, чтобы купить продукты и необходимые вещи, хоть и по-прежнему на распродажах.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Здесь, как отмечает многодетная мама, уже многое зависит от совести родителей, их образа жизни, которые не должны забывать, что деньги выделяются именно на заботу о детях.' | typograf }}
          </p>
          <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[4]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.05*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'У девушки появилось чувство, что стране не плевать на то, что происходит в ее жизни, ведь есть и другие меры поддержки. Так, Хлебова рада, что ей возвращается 100 процентов от платы за детсад, 30 процентов платы за коммунальные услуги.' | typograf }}
          </p>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'Радуют Юлию и единовременные выплаты, которые позволяют подготовить ребенка к школе. «Собираюсь идти оформлять в ПФР новые пособия, которые платят на основании решения суда об алиментах. На старшую дочь. Говорят, что там много вопросов задают личного характера. Ну, посмотрим. Мне даже интересно», — заключила она.' | typograf }}
          </p>
        </div>
      </div>
    </section>

    <section class="article-text">
      <div class="article__img article__img6 img-w" v-animate-onscroll="'animated fadeInRight'">
        <img src="@/assets/img/article1/img7.png" alt="">
      </div>
      <div class="article__img article__img7 img-w" v-animate-onscroll="'animated fadeInLeft'">
        <img src="@/assets/img/article1/img8.png" alt="">
      </div>
      <div class="article-wrapper article-wrapper--mt3">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Могу дать ребенку больше»' | typograf }}
        </h3>
        <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
          {{'«В России теперь действует очень простая и эффективная поддержка семей и матерей, которые воспитывают в одиночку своих детей, — говорит создательница уникального реабилитационного проекта для людей с инвалидностью «Квартал Луи», сенатор от Пензенской области и член президиума генсовета партии «Единая Россия» Мария Львова-Белова. — Я веду регулярный прием граждан в регионе, и часто приходят именно мамы, у которых пятеро, шестеро, семеро детей. Они говорят, что пособия на ребят от 3 до 7 лет и другие меры поддержки, которые сейчас существуют, дают им возможность по-настоящему чувствовать себя защищенными».' | typograf }}
        </p>
        <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[5]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'По словам сенатора, в России не только на словах, но и на деле дают реальные, весомые гарантии поддержки будущим родителям. Подобные пособия тому доказательство.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Мария вместе с коллегами курирует более десяти многодетных семей и видит, как их благосостояние сейчас растет и как оно укрепляет их самостоятельность. «Некоторые уже, опираясь на увеличенные пособия, отказываются от нашей помощи в оплате жилья. Им важно, что они могут платить самостоятельно, без поддержки благотворительных организаций и меценатов», — говорит она.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Новый адресный подход позволил увеличить пособия нуждающимся.' | typograf }}
        </p>
        <div class="article-text__quote2" v-animate-onscroll="'animated fadeInUp'">
          <div class="article-text__quote-icon img-w">
            <img src="@/assets/img/quote.png" alt="">
          </div>
          {{ '«Одни теперь получают 50 процентов от прожиточного минимума в регионе, другие — 75, третьи — 100. Мы отсекаем ситуации, когда семьи умышленно скрывают свой доход, и стараемся оказывать максимальную помощь тем, кому это действительно необходимо», — объяснила собеседница.' | typograf }}
        </div>
        <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
          <span class="char"
                v-for="(letter, index) in titles[6]"
                :key="letter.id"
                :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
        </div>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Она подчеркнула, что когда у нее не было сенаторской зарплаты, то пособия от государства были для нее всегда ощутимой и важной поддержкой.' | typograf }}
        </p>
        <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
          {{ '«Я понимала, что на эти деньги смогу ребенка в школу собрать, оплатить какой-то кружок, — вспоминает Мария. — Эти пособия дают уверенность, не в том плане даже, что я куплю продукты и оплачу коммуналку, а в том, что я могу дать ребенку больше необходимого минимума, могу вложиться в его дополнительное развитие, дать ему реализоваться в творческом плане».' | typograf }}
        </p>
      </div>
      <div class="article-text__shifted-box">
        <div class="article__img article__img8 img-w">
          <img src="@/assets/img/article1/img9.png" alt="">
        </div>
        <div class="article__line article__line5 img-w"  v-animate-onscroll="'animated fadeInDown'">
          <img src="@/assets/img/article1/line5.png" alt="">
        </div>
        <div class="article-wrapper article-wrapper--shifted-right">
          <div class="article-text__quote article-text__quote--blue" v-animate-onscroll="'animated fadeInUp'">
            <span class="char"
                  v-for="(letter, index) in titles[7]"
                  :key="letter.id"
                  :style="{ animationDelay: 0.1*index + 's'}" v-html="letter + ' '"></span>
          </div>
          <p class="article-text__text" v-animate-onscroll="'animated fadeInUp'">
            {{ 'В эффективности такого рода выплат, как оказалось, убежден и известный своим скептицизмом нынешний глава Счетной палаты России Алексей Кудрин.' | typograf }}
          </p>
          <div class="article-text__quote2" v-animate-onscroll="'animated fadeInUp'">
            <div class="article-text__quote-icon img-w">
              <img src="@/assets/img/quote.png" alt="">
            </div>
            {{ '«Это прообраз того, как можно двигаться дальше и по более высоким возрастам. Но самое важное, что это абсолютно разумные и посильные для государства цифры, это, по сути, несколько сотен миллиардов рублей, которые позволили бы снизить уровень бедности примерно в два раза», — рассказал он журналистам.' | typograf }}
          </div>
        </div>
      </div>
      <div class="article-wrapper">
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          В 2020 году выплаты получили <br>
          родители 4 750 000 детей <br>
          <div class="article-text__h3-data">
            <span>Источник:</span> Минтруд
          </div>
        </h3>
        <p class="article-text__subtitle" v-animate-onscroll="'animated fadeInUp'">
          {{'«Благодаря инициативам нашего президента удалось выстроить сейчас целую систему материальной поддержки российских семей. И мы в рамках партийного проекта “Крепкая семья” будем и дальше держать на контроле то, как реализуются эти меры поддержки в реальности», — подытожила Ольга Окунева.' | typograf }}
        </p>
        <p class="article-text__enlarged" v-animate-onscroll="'animated fadeInUp'">
          {{ 'Так, уже в ближайшем будущем она с коллегами собирается добиваться расширения возможностей использования семьями материнского капитала.' | typograf }}
        </p>
        <h3 class="article-text__h3" v-animate-onscroll="'animated fadeInUp'">
          Пособие на ребенка в возрасте <br>
          от 3 до 7 лет. Что важно знать?
        </h3>
      </div>
    </section>

    <div class="info">
      <h3 class="info__title">
        {{ 'Виды и размеры пособий:' | typograf }}
      </h3>
      <div class="info__columns">
        <div class="info__column">
          <div class="info__column-title">
            БАЗОВОЕ <br> ПОСОБИЕ
          </div>
          <div class="info__amount">50%</div>
          <div class="info__amount-descr">
            от прожиточного <br>
            минимума*
          </div>
        </div>
        <div class="info__column">
          <div class="info__column-title">
            ПОВЫШЕННОЕ <br> ПОСОБИЕ
          </div>
          <div class="info__amount">75%</div>
          <div class="info__amount-descr">
            от прожиточного <br>
            минимума**
          </div>
        </div>
        <div class="info__column">
          <div class="info__column-title">
            СПЕЦИАЛЬНОЕ <br> ПОСОБИЕ
          </div>
          <div class="info__amount">100%</div>
          <div class="info__amount-descr">
            от прожиточного <br>
            минимума***
          </div>
        </div>
      </div>
      <h3 class="info__title">
        {{ 'Кто может получить пособие?' | typograf }}
      </h3>
      <p class="info__text">
        {{ 'Семьи с доходом на каждого члена ниже прожиточного минимума(включая студентов-очников в возрасте до 23 лет)' | typograf }}
      </p>
      <h3 class="info__title">
        {{ 'Что не помешает получить пособие?' | typograf }}
      </h3>
      <ul class="info__columns">
        <li>КВАРТИРА****</li>
        <li>ДОМ</li>
        <li>ГАРАЖ</li>
        <li>МАШИНА</li>
        <li>МОТОЦИКЛ </li>
      </ul>
    </div>

    <div class="info-stars">
      <p class="info-stars__text" v-animate-onscroll="'animated fadeInLeft'">
        {{ 'прожиточный минимум в каждом регионе определяется индивидуально' | typograf }}
      </p>
      <p class="info-stars__text" v-animate-onscroll="'animated fadeInLeft'">
        {{ 'выплачивается, если среднедушевой доход семьи после получения базового пособия остается ниже прожиточного минимума' | typograf }}
      </p>
      <p class="info-stars__text" v-animate-onscroll="'animated fadeInLeft'">
        {{ 'выплачивается, если среднедушевой доход семьи остается ниже прожиточного минимума даже при выплате 75-процентного пособия' | typograf }}
      </p>
      <p class="info-stars__text" v-animate-onscroll="'animated fadeInLeft'">
        {{ 'у семьи не должно быть больше одного объекта одного вида собственности' | typograf }}
      </p>
    </div>
  </div>
</template>

<script>
import './article.styl'
import './info.styl'
import Loading from '@/components/Loading/Loading.vue'
import Layers from '@/components/Layers/Layers.vue'

export default {
  name: 'Article1',
  data () {
    return {
      observer: null,
      isLoading: false,
      titles: [
        ['И', 'тут', 'началась', 'череда', 'неприятностей', 'на', 'работе'],
        ['«Меня', 'много', 'раз', 'посылали', 'на', 'аборт', 'с', 'двойняшками,', 'обзывали', 'дурой', 'и', 'ненормальной.', 'Говорили,', 'что', 'я', 'пложу', 'нищету»', '<br>', 'Юлия Хлебова'],
        ['Юлия', 'с', 'тремя', 'детьми', 'ютится', 'в', 'однокомнатной', 'квартире'],
        ['«Есть', 'чувство', 'вины', 'за', 'то,', 'что', 'неправильно', 'живешь,', 'что', 'все', 'сделал', 'не', 'так,', 'не', 'сумел', 'создать', 'семью.', 'Иногда', 'я', 'чудовищно', 'устаю', 'от', 'этого', 'чувства»', '<br>', 'Юлия Хлебова'],
        ['«Я', 'благодарна', 'очень', 'тем,', 'кто', 'добился', 'повышения', 'пособий', 'для', 'таких,', 'как', 'я.', 'Даже', 'в', 'СССР,', 'насколько', 'знаю,', 'такой', 'поддержки', 'не', 'было', 'для', 'женщин,', 'находящихся', 'в', 'моем', 'положении»', '<br>', 'Юлия Хлебова'],
        ['«Теперь', 'у', 'матерей', 'возникло', 'ощущение,', 'что', 'государство', 'о', 'них', 'заботится»', '<br>', 'Cенатор', 'Мария', 'Львова-Белова'],
        ['Львова-Белова', 'с', 'супругом', 'воспитывает', 'девятерых', 'детей', 'и', 'еще', 'восемь', 'ребят', 'находится', 'под', 'ее', 'опекой'],
        ['«Для', 'каждой', 'семьи', 'важно', 'иметь', 'дополнительный', 'ресурс', 'для', 'гармоничного', 'развития', 'ребенка»', '<br>', 'Сенатор Мария Львова-Белова']
      ]
    }
  },
  components: {
    Loading, Layers
  },
  methods: {
    disable () {
      const target = document.querySelector('#app')
      target.ontouchstart = (e) => {
        e.preventDefault()
      }
    },
    enable () {
      const target = document.querySelector('#app')
      target.ontouchstart = () => {
        return true
      }
    },
    onDone () {
      (document.getElementById('element-container')).classList.remove('-scale', '-no-blue')
      document.querySelector('html').classList.remove('-lock')
      this.enable()
    },

    onIntersection (entries) {
      entries.forEach((entry) => {
        entry.target.classList.toggle('-visible', entry.isIntersecting)

        if (entry.target.classList.contains('-visible')) {
          (document.getElementById('element-container')).classList.add('-scale')

          document.querySelector('html').classList.add('-lock')
          this.disable()
          this.isLoading = true

          setTimeout(() => {
            const layers = document.querySelectorAll('.bottom-layer')
            for (const layer of layers) {
              layer.classList.toggle('is-active')
            };

            this.$scrollTo('#element', 1800, { cancelable: false, offset: -60, onDone: this.onDone, onCancel: this.onDone })

            this.observer.disconnect()
          }, 1500)
        }
      })
    },

    initObserver () {
      this.observer = new IntersectionObserver(this.onIntersection, {
        root: null,
        threshold: 0.5
      })

      const nodes = document.querySelectorAll('.observer-move')

      nodes.forEach((node) => {
        this.observer.observe(node)
      })
    }
  },
  mounted () {
    this.initObserver()
  }
}
</script>

<style scoped lang="stylus">
#element-container
  transition: all 1s ease-out

  &.-no-blue
    background #fff

    .article__line6
      opacity 0

  #element-content
    transform-origin 50% 0
    transition: all 0.4s ease-out

  &.-scale
    #element-content
      transition: none
      transform scale(0.8)

.article__img1
  position: absolute
  width: 20rem
  left: 0
  top: 22rem

.article__img2
  position: absolute
  width: 22rem
  right: 0
  top: 65rem

.article__img3
  position: absolute
  width: 55rem
  left: 0
  top: 0
  z-index: 15

.article__img4
  position: absolute
  width: 59rem
  right: 0
  top: 0
  z-index: 15

  @media(max-width: 950px)
    float: right

.article__img5
  position: absolute
  width: 59rem
  left: 0
  top: 0
  z-index: 15

.article__line3
  position: absolute
  width: 38rem
  right: 0
  top: 4rem
  z-index: 4

.article__img6
  position: absolute
  width: 28rem
  right: 0
  top: 0

  @media(max-width: 950px)
    float: right
    width: 15rem
    margin: 0

.article__line4
  position: absolute
  width: 35rem
  left: 0
  top: 4rem
  z-index: 4

.article__img7
  position: absolute
  width: 29rem
  left: 0
  top: 85rem

  @media(max-width: 950px)
    display: none

.article__img8
  position: absolute
  width: 59rem
  right: 0
  top: 0
  z-index: 15

  @media(max-width: 950px)
    float: right

.article__line5
  position: absolute
  width: 38rem
  right: 0
  top: 4rem
  z-index: 4

.article__line2
  position: absolute
  width: 47rem
  left: 0
  top: 2.5rem
  z-index: 14

.article__line6
  position: absolute
  right: 3rem
  top: 10rem
  width: 85rem
  transition: all 0.4s ease-out

  img
    transform: rotate(-7deg)
</style>
